export const VuiHorizontalRule = () => <hr className="vuiHorizontalRule" />;
